import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { GlobalStoreModule } from './global-store.module';

import { GlobalInterceptor } from './interceptors/global.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule, GlobalStoreModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalInterceptor,
      multi: true,
    },
  ],
})
export class GlobalModule {}
